import React, {useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {ArticleApi} from '../../scaffold';
import {Card, Divider, Space, Spin} from 'antd';
import AppSideLayout from '../../components/layouts/AppSideLayout';
import Title from 'antd/lib/typography/Title';
import Text from 'antd/lib/typography/Text';
import moment from 'moment';
import BraftEditor from 'braft-editor';
import {Config} from '../../config';
import ArticleDetailCard from '../../components/article/DetailCard';

export default function ArticleDetailPage() {
  const {id} = useParams<{id: string}>();
  const findHook = useOpenApiFpRequest(ArticleApi, ArticleApi.prototype.articleFindGet);
  useEffect(() => {
    findHook.requestSync({id: parseInt(id)});
  }, [id]);

  return (
    <Spin spinning={findHook.loading}>
      {!!findHook.data ? (
        <AppSideLayout title={findHook.data.catalogs || ''}>
          <ArticleDetailCard article={findHook.data} />
        </AppSideLayout>
      ) : (
        <div style={{height: 300}} />
      )}
    </Spin>
  );
}
